export default "__VITE_ASSET__Bt8H_K4j__"